import React from 'react';

import { ChatBubble } from '../../../ChatBubble';

import style from './Description.scss';

import cn from 'classnames';
import { Link } from 'gatsby';

interface IProps {
  primary_author: {
    name: string;
    slug: string;
    profile_image: string;
    bio: string;
  };
}

export const PostAuthorDescription = ({ primary_author }: IProps) => {
  const { slug, name, bio } = primary_author;
  return (
    <div className={cn(style.wrapper)}>
      <ChatBubble primaryAuthor={primary_author} isAuthor>
        <Link to={`/author/${slug}/`}>
          <div className={style.name}>{name}</div>
        </Link>
        <div dangerouslySetInnerHTML={{ __html: bio }} />
      </ChatBubble>
    </div>
  );
};
